import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

    private configuration: any;
    private environment: any;

  constructor(private http: HttpClient) { }

  loadConfig() {
    //return this.http.get(`${document.baseURI}assets/config/app.config.json`)
    //  .toPromise()
    //  .then(data => {
    //    this.configuration = data;
    //  });

    return this.http.get(`${document.baseURI}assets/config/environment.json`)
        .toPromise()
        .then((data: string) => {
            this.environment = data.indexOf("#{EnvironmentName}") > -1 ? "" : `.${data}`;
            //this.environment = ".development";
            //console.log(this.environment);
        })
        .then(a => this.http.get(`${document.baseURI}assets/config/app.config${this.environment}.json`)
            .toPromise()
            .then(data => {
            this.configuration = data;
        }));


  }

  getConfig() {
    return this.configuration;
  }
}
